import { RichText } from '../i18n/RichText';
import { t } from '../services/language-manager';
import logo from '../assets/mediabriz-logo-svg-400px.svg';

interface WelcomePageProps {
  onNext: () => void;
}

export function WelcomePage({ onNext }: WelcomePageProps) {
  return (
    <div className="card" style={{ textAlign: 'center' }}>
      <img src={logo} alt="Mediabriz" className="wizard-header__logo" style={{ height: '56px', marginBottom: '16px' }} />
      <div className="card__title">{t('welcome-title')}</div>
      <div className="card__subtitle">{t('welcome-subtitle')}</div>

      <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: '20px 0 8px' }}>
        <RichText k="welcome-cta" values={{ next: <strong>{t('welcome-next')}</strong> }} />
      </p>

      <p style={{ fontSize: '12px', color: 'var(--text-muted)', margin: '0 0 24px', fontStyle: 'italic' }}>
        {t('welcome-trial-note')}
      </p>

      <div className="btn-group" style={{ justifyContent: 'center' }}>
        <button className="btn btn--primary" onClick={onNext}>
          {t('welcome-next')}
        </button>
      </div>
    </div>
  );
}
